import React, { useState } from 'react'
import { makeStyles, useTheme } from '@mui/styles'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import clsx from 'clsx'

import PropTypes from 'prop-types'

import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

import IconArrowDown from '@assets/images/icons/arr_down.svg'
import { FillTransition } from '@/modules/base/transitions/index'

const useStyles = makeStyles((theme) => ({
  label: {
    textAlign: 'left',
    fontSize: 13,
    marginBottom: 10,
    '&.disabled': {
      color: '#ccc',
    },
  },
  selectIcon: {
    height: 16,
    right: 10,
    position: 'absolute',
    pointerEvents: 'none',
    top: 14,
    opacity: '.5',
  },
  container: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    '& .Mui-focused': {
      backgroundColor: 'transparent',
    },
    '& .MuiInput-underline': {
      border: `1px solid ${theme.borderColor}`,
      borderRadius: 4,
      '&::before': {
        display: 'none',
      },
      '&::after': {
        display: 'none',
      },
    },
  },
  selectContainer: {
    height: '100%',
  },
  select: {
    background: '#f6f7fa',
    textAlign: 'left',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    '& .MuiSelect-select': {
      padding: '0px 20px',
    },
    '&.disabled': {
      background: theme.white,
    },
    '&.placeholder': {
      color: 'hsl(0, 0%, 50%)',
    },
  },
  placeholderHidden: {
    display: 'none',
  },
  highlight: {
    borderColor: `${theme.colors.yellow} !important`,
    background: `${theme.yellowBackground} !important`,
  },
}))

const DOSelect = (props) => {
  const {
    options,
    onChange,
    value,
    label,
    disabled,
    placeholder,
    showFillAnimation,
    fillAnimationOptions,
  } = props
  const classes = useStyles()
  const [showPlaceholder, setShowPlaceholder] = useState(value === 'none')

  return (
    <div className={classes.container}>
      {label && <span className={clsx(classes.label, { disabled })}>{label}</span>}
      <FillTransition {...fillAnimationOptions}>
        <div className={classes.selectContainer}>
          <Select
            disabled={disabled}
            variant="standard"
            IconComponent={() => (<SVGIcon className={classes.selectIcon} height={16} width={16} svg={IconArrowDown} />)}
            defaultValue='none'
            className={clsx(classes.select, showFillAnimation && classes.highlight, { disabled, placeholder: !value })}
            labelId="select-label"
            value={value ?? 'none'}
            onFocus={(e) => setShowPlaceholder(false)}
            onClose={(e) => setShowPlaceholder(e.target.value === undefined)}
            onChange={onChange}>
            {placeholder && <MenuItem className={clsx(classes.placeholder, !showPlaceholder ? classes.placeholderHidden : null)} key="0" disabled value="none" >{placeholder}</MenuItem>}
            {options.map(({ value, label }) => <MenuItem key={value} value={value}>{label}</MenuItem>)}
          </Select>
        </div>
      </FillTransition>
    </div>
  )
}

DOSelect.propTypes = {
  options: PropTypes.array,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showFillAnimation: PropTypes.bool,
}

export default DOSelect
